<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-2"
          primary-title
        >
          Setar Workflow
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="$emit('input')"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="workflow"
            :items="workflows"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Workflow"
            hide-details
            prepend-icon="description"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  props: ['value', 'atividade', 'loading'],
  data() {
    return {
      workflow: null
    }
  },
  watch: {
    value(v) {
      if (v && !this.workflows.length) {
        this.fetchWorkflows();
      }
    }
  },
  methods: {
    ...mapActions(['fetchWorkflows',]),
    ...mapMutations([
      'showNotification'
    ]),
    adiciona() {
      if (this.workflow) {
        if (this.atividade !== null) {
          this.atividade.IdWorkflow = this.workflow.IdWorkflow;
          this.atividade.Workflow = this.workflow.Descricao;
          this.$emit('setaWorkflow', this.atividade);
          this.workflow = null;
        } else {
          this.$emit('setaWorkflowSelected', this.workflow);
          this.workflow = null;
        }
      } else {
        this.showNotification({ text: 'Informe o workflow', status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(['workflows'])
  }
}
</script>

<style>

</style>
